// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608130118/js/" + chunkId + "." + {"44":"c431ef79","225":"60998962","481":"53a00ab7","486":"19e378df","770":"d9e35fa3"}[chunkId] + ".0.4245207328978067.chunk.js";
};